<template>
    <section id="realisations" class="realisations container">
        <header>
            <h1>Réalisations</h1>
            <Select :options="[{
                name:'En cours',
                value:'in-progress'
            },{
                name:'Habitations',
                value:'habitations'
            },{
                name:'Transformations',
                value:'transformations'
            },{
                name:'Immeubles à appartement',
                value:'building'
            },{
                name:'Programmes mixtes',
                value:'mixtes'
            }]" v-model="currentCategory"></Select>
            <div class="tabs">
                <ul class="d-flex">
                    <li>
                        <button :class="currentCategory === 'in-progress' ? 'active' : null"
                                @click="filterCategory('in-progress')">En cours
                        </button>
                    </li>
                    <li>
                        <button :class="currentCategory === 'habitations' ? 'active' : null"
                                @click="filterCategory('habitations')">Habitations
                        </button>
                    </li>
                    <li>
                        <button :class="currentCategory === 'transformations' ? 'active' : null"
                                @click="filterCategory('transformations')">Transformations
                        </button>
                    </li>
                    <li>
                        <button :class="currentCategory === 'building' ? 'active' : null"
                                @click="filterCategory('building')">Immeubles à appartement
                        </button>
                    </li>
                    <li>
                        <button :class="currentCategory === 'mixtes' ? 'active' : null"
                                @click="filterCategory('mixtes')">Programmes Mixtes
                        </button>
                    </li>
                </ul>
            </div>
            <transition-group name="list" tag="div" class="works d-flex">
                <div class="work" v-for="work in worksToDisplay" :key="work.id">
                    <div class="overflow">
                        <div class="img-container"
                             :style="{background:'url('+work.url+')', 'background-position':'center center', 'background-size':'cover'}"
                             :key="work.id"
                             @click="openModal(work.id)"
                        >
                            <img :src="work.url" alt="" :key="work.id">
                        </div>
                    </div>
                </div>
            </transition-group>
            <div v-if="worksToDisplay.length === 0"><strong>Pas de biens correspondants</strong></div>
        </header>
    </section>
</template>

<script>
    import {EventBus} from "../bus"
    import Select from "./core/Select"

    export default {
        name: "Realisations",
        props: ["works"],
        components: {
            Select
        },
        data() {
            return {
                worksToDisplay: [],
                currentCategory: ""
            }
        },
        watch: {
            currentCategory() {
                this.worksToDisplay = this.works.filter((el) => {
                    if (el.category.includes(this.currentCategory))
                        return el;
                    return false
                })
            }
        },
        methods: {
            filterCategory(category) {
                this.currentCategory = category
            },
            openModal(selector) {
                EventBus.$emit("change_modal", {
                    modal: true,
                    properties: this.worksToDisplay.filter(el => el.id === selector)
                })
            }
        },
        created() {
            this.filterCategory("in-progress")
        }
    }
</script>

<style>
    .list-leave-active {
        transition: all .5s;
    }

    .list-enter-active {
        transition: all .5s;
        transition-delay: .5s;
    }

    .list-enter {
        opacity: 0;
        transform: translateY(-30px);
    }

    .list-leave-to /* .list-leave-active for <2.1.8 */
    {
        opacity: 0;
        transform: translateY(30px);
    }
</style>